// ArChat Auto-Normalized File
// Created: 12-03-2026 22:38:36
// Author: SIVOL® - Aldo Frias - Argentina

import { plansTranslationsEn } from './plansTranslations.en.js';
export const plansTranslationsJa = {
  ...plansTranslationsEn,
  'plans.founder.remaining': 'Founder枠あと{count}',
  'plans.founder.remaining_last': 'Founder枠残り{count}',
  'plans.founder.remaining_limited': '限定：残り{count}枠',
  'plans.founder.remaining_very_low': 'Founder枠あと{count}のみ',
  'plans.founder.soldout': 'Founder完売',
  'plans.foundation.best_value': '',
  'plans.foundation.savings': '',
  'plans.compare.pro.adjustment_notice': '価格はサービス条件に応じて変更される場合があります。',
  'plans.compare.title': 'Choose your plan',
  'plans.compare.free.title': 'FREE',
  'plans.compare.foundation.title': 'FOUNDATION ⭐',
  'plans.compare.pro.title': 'PRO',
  'plans.compare.foundation.badge': '150 limited slots',
  'plans.compare.cta.foundation': 'Become a Founder',
  'plans.compare.cta.pro': 'Upgrade to PRO',
  'plans.compare.active': 'Current plan',
  'plans.compare.limited': '',
  'plans.limit.title.messages': 'Message limit reached',
  'plans.limit.message.messages': 'You reached your message limit. Upgrade to FOUNDATION or PRO.',
  'plans.limit.title.storage': 'Storage limit reached',
  'plans.limit.message.storage': 'You reached your storage limit. Upgrade to upload more files.',
  'plans.limit.title.invitations': 'Invitation limit reached',
  'plans.limit.message.invitations': 'You reached your invitation limit. Upgrade to invite more.',
  'plans.limit.reached': 'Limit reached — Upgrade plan',
  'plans.compare.institucional.title': 'Title',
  'plans.compare.yourPlan': 'YourPlan',
  'plans.modal.title': 'プランをアップグレード',
  'plans.modal.comparison_title': 'プラン比較',
  'plans.modal.billing_period': '',
  'plans.modal.price_note': '',
  'plans.modal.free.line1': 'アカウントあたり月 30,000 文字。',
  'plans.modal.free.line2': 'ユーザーあたり最大 2 件の連絡先。',
  'plans.modal.free.line3': 'アカウントあたり最大 2 件のアクティブな会話。',
  'plans.modal.free.line4': 'ファイル添付やストレージはありません。',
  'plans.modal.free.line5': 'データのエクスポートはありません。',
  'plans.modal.free.line6': 'メッセージ履歴は最大 30 日間。',
  'plans.modal.free.line7': 'ユーザーあたりデバイスは 1 台のみ。',
  'plans.modal.premium.line1': 'アカウントあたり月 300,000 文字。',
  'plans.modal.premium.line2': 'ユーザーあたり最大 100 件の連絡先。',
  'plans.modal.premium.line3': '会話とチャットは無制限（テナント）。',
  'plans.modal.premium.line4': '最大 50 MB のストレージ（テナント）。',
  'plans.modal.premium.line5': 'ユーザーあたり最大 3 台のデバイス。',
  'plans.modal.premium.line6': '招待は無制限（テナント）。',
  'plans.modal.premium.line7': 'プランの上限内でのエクスポート、自動翻訳、ファイルを含みます。',
  'plans.modal.premium_block_heading': 'エンジン利用上限（プレミアム）',
  'plans.modal.foundation.ribbon': 'Founder Access',
  'plans.modal.foundation.program_title': 'Founder プログラム',
  'plans.modal.foundation.categories_title': 'Founder カテゴリ（{slots} 枠）',
  'plans.modal.foundation.cat_legendary_title': 'LEGENDARY Founder',
  'plans.modal.foundation.cat_legendary_range': '順位 1–25',
  'plans.modal.foundation.cat_legendary_desc': '最初に支援した方々。最も高い歴史的優先度。',
  'plans.modal.foundation.cat_early_title': 'EARLY Founder',
  'plans.modal.foundation.cat_early_range': '順位 26–75',
  'plans.modal.foundation.cat_early_desc': '特別な認知を伴う早期支援。',
  'plans.modal.foundation.cat_std_title': 'Founder',
  'plans.modal.foundation.cat_std_range': '順位 76–150',
  'plans.modal.foundation.cat_std_desc': '150 枠内の Founder 枠。',
  'plans.modal.foundation.advantages_title': 'Founder の特典',
  'plans.modal.foundation.adv1': '限定 Founder プール（{slots} の番号付き枠）へのアクセス。',
  'plans.modal.foundation.adv2': 'ArChat の創設ユーザーとしての認知。',
  'plans.modal.foundation.adv3': 'プロダクト体験における Founder バッジと存在感。',
  'plans.modal.foundation.adv4': '順位（1–150）に応じた歴史的優先度とステータス。',
  'plans.modal.foundation.adv5': '現行ポリシーが適用される限り、Founder アクセスに紐づく継続的な特典。',
  'plans.modal.pro.tagline': '標準プレミアム — Founder コンポーネントなし',
  'plans.badges.foundation': 'Founder',
  'plans.free.title': 'FREE',
  'plans.free.subtitle': '無料プラン',
  'plans.free.features.contacts': 'ユーザーあたり最大2件の連絡先',
  'plans.free.features.conversations': 'アカウントあたり最大2件の進行中の会話',
  'plans.free.features.no_export': 'アカウントあたり月3万文字；1日34・月1000メッセージ；エクスポートなし',
  'plans.free.features.no_advanced': 'ファイル・ストレージなし；30日履歴；ユーザーあたり端末1台',
  'plans.foundation.title': 'FOUNDATION',
  'plans.foundation.subtitle': 'Founderプラン',
  'plans.foundation.features.contacts': 'PROと同じプレミアム契約（ユーザーあたり最大100件）',
  'plans.foundation.features.conversations': 'テナント内チャット無制限；PROと同じ上限',
  'plans.foundation.features.badge': 'Founderプログラム（番号付き150枠）',
  'plans.foundation.features.support': 'Founder枠がある間は月USD15',
  'plans.pro.title': 'PRO',
  'plans.pro.subtitle': 'Proプラン',
  'plans.pro.features.contacts': 'ユーザーあたり最大100件の連絡先',
  'plans.pro.features.conversations': 'テナント内チャット無制限；1日1667・月5万件',
  'plans.pro.features.export': 'テナント最大50MB；エクスポート・自動翻訳・ファイルはプランに準拠',
  'plans.pro.features.notifications': 'ユーザーあたり端末最大3台；テナント招待は無制限',
  'plans.actions.free': '現在のプラン',
  'plans.actions.foundation': 'Founderになる',
  'plans.actions.pro': 'PROにアップグレード',
  'plans.badges.recommended': 'おすすめ',
  'plans.badges.limited': '限定',
  'plans.payments_disabled.title': 'サブスクリプション',
  'plans.payments_disabled.message': 'サブスクリプションは順次有効化されています。利用可能なプランとその特典をご覧いただけます。',
  'plans.payments_disabled.confirm': 'OK',
};